export default __webpack_public_path__ + "344d36df27d0ca2daeb74b95db4b44e8.png";